import styled from "@emotion/styled";
import { PRIMARY_BLUE } from "src/constants/colors";

export const Container = styled.div`
  background-color: #fafafb;
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  svg {
    color: ${PRIMARY_BLUE};
    width: 40px;
    height: 40px;
  }
`;
